import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  min-height: 60vh;
  padding: 40px;
`;

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 64px;
  height: 64px;
  margin-bottom: 24px;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${colors.onSurface};
  margin-bottom: 8px;
`;

export const Text = styled.p`
  max-width: 380px;
  color: ${colors.onSurfaceVariant};
  font-size: 14px;
`;
